module.exports = {
    'Open Sans Condensed': {
        Regular: 'Light'
    },

    Default: {
        Regular: 'Regular'
    }
};
